/**
 * @ngdoc directive
 * @name icon
 *
 * @description
 * Icon component
 */
module.directive('icon', function () {
    'use strict';
    return {
        restrict: 'E',
        replace: true,
        scope: {
            label: '@',
            type: '@',
            size: '@?'
        },
        link: function(scope, element, attr) {
            if (attr.ngClick) {
                scope.isButton = true;
            }
        },
        template:
            '<div class="aqua-icon--container" ng-class="{\'aqua-icon--container--{{size}}\': size}">' +
            '   <button ng-if="isButton" class="aqua-icon aqua-icon--{{type}}" aqua-background-img="images/ico-{{type}}.svg" title="{{label}}"><span class="is-sr-only">{{label}}</span></button>' +
            '   <div ng-if="!isButton" class="aqua-icon aqua-icon--{{type}}" aqua-background-img="images/ico-{{type}}.svg" title="{{label}}"><span class="is-sr-only">{{label}}</span></div>' +
            '</div>'
    };
});